import { RouteRecordRaw } from "vue-router";
import DummyRouterView from "@/components/common/DummyRouterView.vue";
import { authorizationMiddleware } from "../middleware";
import store from "@/store";
import { numericParser } from "@/router/parsers";

const routes: RouteRecordRaw = {
  path: "usuarios",
  name: "admin-users-main",
  component: DummyRouterView,
  children: [
    {
      path: "",
      name: "admin-users",
      component: () =>
        import(
          /* webpackChunkName: "admin" */ "../../views/admin/user/Index.vue"
        ),
    },
    {
      path: "crear",
      name: "admin-users-create",
      component: () =>
        import(
          /* webpackChunkName: "admin" */ "../../views/admin/user/Create.vue"
        ),
      meta: {
        middlewares: [authorizationMiddleware],
        permissions: new Map([
          [
            "entity/create-users",
            { userRoleId: () => store.state.authUser?.user?.roleId },
          ],
        ]),
      },
    },
    {
      path: ":userId/editar",
      name: "admin-users-edit",
      component: () =>
        import(
          /* webpackChunkName: "admin" */ "../../views/admin/user/Edit.vue"
        ),
      meta: {
        middlewares: [authorizationMiddleware],
        permissions: new Map([
          [
            "entity/edit-users",
            { userRoleId: () => store.state.authUser?.user?.roleId },
          ],
        ]),
      },
      props: (route) => ({
        ...numericParser(route, "userId"),
      }),
    },
    {
      path: ":userId/eliminar",
      name: "admin-users-delete",
      meta: {
        middlewares: [authorizationMiddleware],
        permissions: new Map([
          [
            "entity/edit-users", // add delete policy
            { userRoleId: () => store.state.authUser?.user?.roleId },
          ],
        ]),
      },
      component: () =>
        import(
          /* webpackChunkName: "admin" */ "../../views/admin/user/Delete.vue"
        ),
      props: true,
    },
  ],
};

export default routes;
